import React from 'react';
import View from './adminView';

const AdminController = () => <View />;

export default AdminController;
